import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "terminal",
  "use": "terminal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"terminal\">\n<path d=\"M4,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L8.6,11L3.3,5.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l6,6\n\tc0.4,0.4,0.4,1,0,1.4l-6,6C4.5,17.9,4.3,18,4,18z\" />\n<path d=\"M20,20h-8c-0.6,0-1-0.4-1-1s0.4-1,1-1h8c0.6,0,1,0.4,1,1S20.6,20,20,20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol